import { ServiceDetailsActions } from "../action";
import { FueldelivF, JumpstartF, LockoutF, RoadsideasstF, TirechangeF } from "../icon-library/lib";
import { ServiceDetailsBreakdown } from "../types";

export type ServiceDetailState = {
  serviceDetails: ServiceDetailsBreakdown[];
  loading: boolean;
  error?: any;
};

const initialState: ServiceDetailState = {
  serviceDetails: [
    {
      id: 1,
      serviceType: "Tow",
      serviceText: "Tow",
      cost: "",
      displayCost: "",
      eta: "",
      icon: RoadsideasstF,
      iconSize: 2,
      service: "tow",
      value: "Tow",
    },
    {
      id: 2,
      serviceType: "Lockout",
      serviceText: "Lockout",
      cost: "",
      displayCost: "",
      eta: "",
      icon: LockoutF,
      iconSize: 1.5,
      service: "lockout",
      value: "Lockout",
    },
    {
      id: 3,
      serviceType: "Gas",
      serviceText: "Fuel Delivery",
      cost: "",
      displayCost: "",
      eta: "",
      icon: FueldelivF,
      iconSize: 1.5,
      service: "gas",
      value: "Fuel Delivery",
    },
    {
      id: 4,
      serviceType: "Changetire",
      serviceText: "Tire Change",
      cost: "",
      displayCost: "",
      eta: "",
      icon: TirechangeF,
      iconSize: 1.5,
      service: "tire",
      value: "Tire Change",
    },
    {
      id: 5,
      serviceType: "Battery",
      serviceText: "Jump Start",
      cost: "",
      displayCost: "",
      eta: "",
      icon: JumpstartF,
      iconSize: 1.5,
      service: "battery",
      value: "Jump Start",
    },
  ],
  loading: false,
  error: false,
};
//TODO check here if this is necessary B-2666100
function replaceServiceCost(serviceCosts: ServiceDetailsBreakdown[]) {
  serviceCosts = serviceCosts || [];

  return initialState.serviceDetails.reduce((accumulator, serviceDetail) => {
    const serviceCostByType =
      serviceCosts.find((serviceCost) => {
        if (!serviceCost?.serviceType) {
          return false;
        }
        return serviceCost?.serviceType === serviceDetail?.serviceType;
      }) || {};

    const mergedService = {
      ...serviceDetail,
      ...serviceCostByType,
    };
    mergedService.originalCost = Math.abs(Number(mergedService.cost)).toFixed(2);
    mergedService.displayCost = Math.ceil(Number(mergedService.cost));
    accumulator.push(mergedService);
    return accumulator;
  }, []);
}

export default function (state: ServiceDetailState = initialState, action: ServiceDetailsActions): ServiceDetailState {
  switch (action.type) {
    case "UPDATE_SERVICE_DETAILS":
      let serviceDetails = replaceServiceCost(action.payload.serviceCosts);
      return { ...state, serviceDetails: [...serviceDetails], loading: false };
    case "REFRESH_REDUCERS":
      return { ...initialState };
    default:
      return state;
  }
}
